// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__zdgu7","head":"Table_head__-QlGj","col":"Table_col__2azo2"};